import styled from '@emotion/styled';
import DisplayLine from './DisplayLine';
import Errors from './Errors';
import { useTranslation } from 'react-i18next';
import { Flex } from './layouts';
import InfoModal from './InfoModal';
import {FC} from "react";

const Container = styled.label<{
  disabled?: CheckProps['disabled'];
  title?: CheckProps['title'];
}>(({ theme, disabled, title }) => ({
  display: 'block',
  position: 'relative',
  paddingLeft: title ? '35px' : null,
  cursor: !disabled ? 'pointer' : null,
  userSelect: 'none',
  minWidth: '20px',
  minHeight: '20px',

  input: {
    position: 'absolute',
    opacity: 0,

    '&:checked ~ span': {
      backgroundColor: theme.colors.primary,

      '&::after': {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '32.5%',
        height: '55%',
        content: "''",
        borderRight: '2.2px solid #fff',
        borderBottom: '2.2px solid #fff',
        transform: 'translate(-45%, -65%) rotate(45deg)'
      }
    }
  }
}));

const CheckMark = styled.span<{
  errors: CheckProps['errors'];
  disabled: CheckProps['disabled'];
}>(({ theme: { colors }, errors, disabled }) => ({
  position: 'absolute',
  top: '50%',
  left: 0,
  height: 20,
  width: 20,
  transform: 'translateY(-50%)',
  border: `1px solid ${errors ? colors.alert : colors.border}`,
  borderRadius: 4,
  backgroundColor: disabled ? colors.secondaryBackground : colors.white
}));

export interface CheckProps {
  value?: boolean;
  onChange?: (e: any) => void;
  name: string;
  errors?: string[] | boolean;
  disabled?: boolean;
  readOnly?: boolean;
  title?: string;
  infoTitle?: string;
  infoText?: string;
}

const CheckBox: FC<CheckProps> = ({
  value,
  onChange,
  name,
  errors,
  disabled,
  title,
  readOnly,
  infoTitle,
  infoText,
  ...props
}) => {
  const { t } = useTranslation();
  if (readOnly) {
    return <DisplayLine label={title} value={value ? t('Ja') : t('Nee')} />;
  }

  return (
    <>
      <Flex>
        <Container {...props} disabled={disabled} title={title}>
          <Flex>{title}</Flex>
          <input
            name={name}
            type="checkbox"
            onChange={e => {
              if (disabled) return;
              onChange({ target: { value: e.target.checked, name } });
            }}
            checked={value}
          />
          <CheckMark {...{ errors, disabled }} />
        </Container>
        {infoText && <InfoModal title={infoTitle}>{infoText}</InfoModal>}
      </Flex>
      {errors && <Errors errors={errors} />}
    </>
  );
};

export default CheckBox;
